import stripePatternImage from '@assets/stripe-pattern-3.png';
import { useEffect } from 'react';
import type { MapRef } from 'react-map-gl/mapbox';

export function useStripePattern(map: MapRef | null) {
  useEffect(() => {
    if (!map) return;
    if (map.hasImage('stripe-pattern')) return;

    map.loadImage(stripePatternImage, (_error, image) => {
      if (!image || map.hasImage('stripe-pattern')) return;
      map.addImage('stripe-pattern', image, { pixelRatio: 2 });
    });
  }, [map]);
}
